module.exports = __webpack_public_path__ + "media/images/products/cards/investimento_global-d1db83c8ad81247b39a3aca4889b1c2d.png";